var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a200da53-39ba-458c-9ea9-670f36c59faf,.b6319d52-0c76-4a72-a059-111848704511{fill:none;}.a8a62389-e327-4e3d-aa8f-961a2dd56e5f{clip-path:url(#ec66e914-aa9e-4a30-8a89-08afd31fd2e0);}.b6319d52-0c76-4a72-a059-111848704511{stroke:#000;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec66e914-aa9e-4a30-8a89-08afd31fd2e0",
    transform: "translate(0 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a200da53-39ba-458c-9ea9-670f36c59faf",
    width: 200,
    height: 200
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "armatura_dubla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bf6e3773-03a7-434a-aaee-25dcc17f8d92",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a8a62389-e327-4e3d-aa8f-961a2dd56e5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190-25.15v209.3a4,4,0,0,1-4,4H14a4,4,0,0,1-4-4V-21.15a4,4,0,0,1,4-4H190M200-33a4,4,0,0,0-4-4H4a4,4,0,0,0-4,4V196a4,4,0,0,0,4,4H196a4,4,0,0,0,4-4Z",
    transform: "translate(0 37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b6319d52-0c76-4a72-a059-111848704511",
    x: 40,
    y: 5.01,
    width: 120,
    height: 190.4,
    rx: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.d691b98c2fcf47d183b0f17b3feb99bf.svg";
export { ForwardRef as ReactComponent };